import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { prePatientMedicine } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/pharmacySlice";

const PrePatientPharmacyMedicine = (id) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["prePatientMedicine",id],
    queryFn: () => prePatientMedicine(id),
    enabled: !!id,
    onError: () => {
      dispatch(setError(true));
      dispatch(setLoading(false));
    },
    onSettled: () => {
      dispatch(setLoading(false));
    },
  });
};

export default PrePatientPharmacyMedicine;
